exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!./../css/variables.css"), "");

// module
exports.push([module.id, ".outer[data-v-b5900138]{position:fixed;left:0;top:0;bottom:0;right:0;z-index:100;display:flex;background:hsla(0,0%,100%,.7)}.outer .inner[data-v-b5900138]{background:var(--azure)}.outer.aqua .inner[data-v-b5900138]{background:var(--aqua)}.outer.light-purple .inner[data-v-b5900138]{background:var(--light_purple)}.inner[data-v-b5900138]{margin:auto}p[data-v-b5900138]{padding:20px;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-b5900138","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/components/NoInteractionOverlay.vue
// module id = 568
// module chunks = 0